import { render } from "./Dictionary.vue?vue&type=template&id=688f38d6&scoped=true&ts=true"
import script from "./Dictionary.vue?vue&type=script&lang=ts"
export * from "./Dictionary.vue?vue&type=script&lang=ts"

import "./Dictionary.vue?vue&type=style&index=0&id=688f38d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688f38d6"]])

export default __exports__